import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography'
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

import VisaRequestDetails from '../common/visa/visa-request-details';
import VisaRequestChips from '../common/visa/visa-request-chips';
import RequestPreview from '../common/request/request-preview';
import RequestDetailsSkeleton from '../common/skeleton/request-details-skeleton';
import RequestInfoSkeleton from '../common/skeleton/request-info-skeleton';
import OfferInfo from '../common/offer-info';
import { Panel, PanelHeader, PanelContent } from '../common/panel';

import { renderAttachment } from '../../../helpers/attachment-helper';
import { checkTokenExpirationMiddleware } from '../../../middlewares/users-auth.middleware';

const VisaOffer = () => {
    const [user] = useState(checkTokenExpirationMiddleware());
    const [loading, setLoading] = useState({
        skeleton: true,
        backdrop: false
    });
    const [visaOffer, setVisaOffer] = useState(null);
    const [, setError] = useState(null);
    const { id } = useParams();
    let history = useHistory();

    let headers = {
        "Authorization": `Bearer ${user.Token}`
    };

    useEffect(() => {
        axios.get(`/api/visaoffer/${id}`, { headers: headers })
            .then(res => {
                setVisaOffer(res.data);
                setTimeout(() => setLoading({ ...loading, skeleton: false }), 500);
            })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }, [])

    const deleteOffer = () => {
        setLoading({ ...loading, backdrop: true });
        axios.delete(`/api/visaoffer/${id}`, { headers: headers })
            .then(res => {
                setTimeout(() => history.push(`/request/${visaOffer.reservationRequestResource.id}/visa`), 500);

            })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }

    return (
        <>
            {
                loading.backdrop ?
                    <Backdrop className="backdrop" open={loading.backdrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    :
                    null
            }
            <Grid container spacing={3}>
                <Grid
                    container item xs={12} md={12} lg={9}
                >
                    <Panel>
                        <PanelHeader>Request Details</PanelHeader>
                        <PanelContent>
                            {loading.skeleton ?
                                <RequestDetailsSkeleton />
                                :
                                visaOffer ?
                                    <>
                                        <RequestPreview
                                            label={"Visa"}
                                            keyword={"Cities"}
                                            reservationRequest={visaOffer.reservationRequestResource}
                                            Details={
                                                <VisaRequestDetails
                                                    visaResources={visaOffer.reservationRequestResource.reservationRequestVisaResources}
                                                />
                                            }
                                            Chips={
                                                <VisaRequestChips
                                                    variant={"default"}
                                                    visaResources={visaOffer.reservationRequestResource.reservationRequestVisaResources}
                                                />
                                            }
                                        />
                                    </>
                                    : null
                            }
                        </PanelContent>
                    </Panel>

                    <Panel>
                        <PanelHeader>Offer Details</PanelHeader>
                        <PanelContent>
                            {loading.skeleton ?
                                <RequestDetailsSkeleton />
                                :
                                visaOffer ?
                                    <>
                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Destination:
                                            </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    {visaOffer.destinationName}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    From Date:
                                            </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    {visaOffer.fromDate.substring(0, 10)}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    To Date:
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={9}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    {visaOffer.toDate.substring(0, 10)}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Visa Type:
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={9}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    {visaOffer.visaType1} ({visaOffer.entriesNumber})
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Price:
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    Adult {visaOffer.adultPrice}  L.E. <br />
                                                    {visaOffer.childPrice ? <>{`Child ${visaOffer.childPrice} L.E.`} <br /></> : null}
                                                    {visaOffer.infantPrice ? `Infant ${visaOffer.infantPrice} L.E.` : null}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Processing Days:
                                            </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    {visaOffer.processingDays}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Requirements:
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography className="pre-wrap" variant="subtitle1" gutterBottom>
                                                    {visaOffer.requirements}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Notes:
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography className="pre-wrap" variant="subtitle1" gutterBottom>
                                                    {visaOffer.notes}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Attachment:
                                            </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    {renderAttachment(visaOffer.attachment)}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </>
                                    : null
                            }
                        </PanelContent>
                    </Panel>
                </Grid>

                <Grid
                    container item xs={12} md={12} lg={3}
                >
                    <div className="side-info">
                        {
                            loading.skeleton ?
                                <RequestInfoSkeleton />
                                :
                                visaOffer ?
                                    <OfferInfo offer={visaOffer} deleteOffer={deleteOffer} />
                                    : null
                        }
                    </div>
                </Grid>
            </Grid>
        </>
    );
}

export default VisaOffer;